import { z } from 'zod';
import apiClient from '../lib/apiClient';

const BACKOFFICE_API_URL = '/backoffice';
const AGENT_SETTINGS_API_URL = `${BACKOFFICE_API_URL}/agent-settings`;

export const AgentSettingsSchema = z.object({
  anthropicApiKey: z.string().nullable(),
  openaiApiKey: z.string().nullable(),
  qdrantUrl: z.string().nullable(),
  qdrantApiKey: z.string().nullable(),
});

export type AgentSettings = z.infer<typeof AgentSettingsSchema>;

export type UpdateAgentSettingsPayload = Partial<{
  anthropicApiKey: string;
  openaiApiKey: string;
  qdrantUrl: string;
  qdrantApiKey: string;
}>;

export const getAgentSettings = async (): Promise<AgentSettings> => {
  const data = await apiClient.get(AGENT_SETTINGS_API_URL);
  return AgentSettingsSchema.parse(data);
};

export const updateAgentSettings = async (
  payload: UpdateAgentSettingsPayload,
): Promise<AgentSettings> => {
  const data = await apiClient.put(AGENT_SETTINGS_API_URL, payload);
  return AgentSettingsSchema.parse(data);
};
